// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + "addbd21d0a1c62460906" + "/js/" + chunkId + ".js";
};